import dayjs from "dayjs";
import { HydratedMetric, HydratedMetricValues } from "../HydratedMetric";
import { HydratedValue } from "../HydratedValue";
import { Period } from "../Period";
import { DeltaBase, DeltaResult } from "./DeltaBase";

export class YTDDelta extends DeltaBase {
    constructor(metric: HydratedMetric, asOfDate: dayjs.Dayjs) {
        super(metric, asOfDate);
    }

    private getYTDPeriods(year: number): Period[] {
        let month = this.asOfDate.month();
        const isCompleteMonth = this.asOfDate.isSame(
            this.asOfDate.endOf("month"),
            "day",
        );
        if (!isCompleteMonth && month > 0) {
            month = month - 1;
        }
        const periods: Period[] = [];
        for (let m = 0; m <= month; m++) {
            periods.push(
                new Period(dayjs().year(year).month(m).startOf("month")),
            );
        }
        return periods;
    }

    getCurrentSlice(): HydratedMetricValues {
        const periods = this.getYTDPeriods(this.asOfDate.year());
        return this.metric.getValuesForPeriods(periods);
    }

    getPreviousSlice(): HydratedMetricValues {
        const periods = this.getYTDPeriods(this.asOfDate.year() - 1);
        return this.metric.getValuesForPeriods(periods);
    }

    protected validate(): DeltaResult | null {
        if (
            this.getCurrentSlice().length === 0 ||
            this.getPreviousSlice().length === 0
        ) {
            return {
                value: new HydratedValue(null, this.metric.type),
                invalidWindowSize: true,
            };
        }
        return null;
    }

    getDeltaLabel(): string {
        return "% Δ YTD";
    }
}
